import { MediaType } from "@/types/media.ts";

export const categoryAttributeDefaultLabels = {
  lastName: "Name",
  eventDate: "Date 1",
  graduationDate: "Date 2",
  activity: "Text 1",
  type: "Text 2",
} as const;

export const entryDefaults = {
  // other defaults defined on backend
  firstName: "NEW PROFILE",
  activity: "Soccer, W Hockey, Tennis",
  type: "Coach",
} as const;

export const CMS_WIDTH = 0.2;
export const INPUT_DEBOUNCE = 500;
export const SEARCH_DEBOUNCE = 350;
export const SEARCH_DEBOUNCE_TOUCHSCREEN = 500;
export const SCROLL_SKEW_ANIMATION_MAX_ITEMS = 400;

export const RAS_MEDIA_SERVER_HOSTNAME = "media.rocketalumnisolutions.com";

/*
On touchscreens, we take certain actions when the screen is inactive
e.g. return to home screen, close open dialogs, etc.
 */
export const IDLE_TIME = 1000 * 2; // 2 seconds
export const DEFAULT_RETURN_HOME_TIMEOUT = 1000 * 60 * 6; // 6 minutes
export const RESET_APP_TIMEOUT = 1000 * 60 * 3; // 3 minutes
export const SEARCH_IDLE_TIMEOUT = 1000 * 10; // 10 seconds
export const SEARCH_IDLE_TIMEOUT_TOUCHSCREEN = 1000 * 30; // 30 seconds
export const VISUAL_DIALOG_RESET_ZOOM_TIMEOUT = 1000 * 60 * 2; // 2 minutes

/*
We emit a global event when a video is playing to ensure
our inactivity detector is aware of the video.
 */
export const VIDEO_PLAYING_GLOBAL_EVENT_NAME = "rasvideoplaying";

/*
We use local storage to indicate if device has been used to log in
previously.
 */
export const DEVICE_DID_AUTH_KEY = "ras-device-did-auth";
export const LS_CMS_LINK_ENABLE = "ras-ls-cms-link-enable";

// Ensure this remains consistent with CSS breakpoints
// see src/v2/styles/breakpoints
export const VIEWPORT = {
  xs: 374,
  sm: 666,
  md: 1040,
  lg: 1400,
  xl: 1920,
};

export const MAX_FILE_SIZE: Record<MediaType, number> = {
  font: 20,
  text: 20,
  video: 50,
  image: 20,
  pdf: 250,
};

export const BODY_TARGET_IDS = {
  appTarget: "app",
  legacyModalTarget: "legacy-modal-target",
  tailwindModalTarget: "tailwind-modal-target",
  tooltipsTarget: "tooltips-target",
  imageLoaderTarget: "image-loader-target",
};

export const DEFAULT_FONTS = {
  font: "Russo One",
  font2: "Russo One",
  font3: "Roboto",
};

export const RAS_SERVICE_AGREEMENT_LINKS = {
  termsOfService:
    "https://rasv2.s3.us-west-2.amazonaws.com/uploads/Terms_of_Service.pdf",
  privacyPolicy:
    "https://prod.media.rocketalumnisolutions.com/Documents/Privacy_Policy.pdf",
  servicesAgreement:
    "https://rasv2.s3.us-west-2.amazonaws.com/uploads/Services_Agreement.pdf",
};

// We overlay backgroundColor on top of the default site-wide image. We use chroma to determine whether the color is light or dark
// To improve color blending, if light, we use the light image, if dark, we use the dark image
export const DEFAULT_SITE_WIDE_BACKGROUND_LIGHT =
  "https://prod.media.rocketalumnisolutions.com/StaticAssets/Default-Site-Wide-Bg.jpg";
export const DEFAULT_SITE_WIDE_BACKGROUND_DARK =
  "https://prod.media.rocketalumnisolutions.com/StaticAssets/Default-Site-Wide-Bg-Dark-New.jpg";

export const DEFAULT_DATE_FORMAT = "YYYY";
